import { AngularEditorConfig } from '@kolkov/angular-editor';

const editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    placeholder: 'Enter your content here...',
    toolbarPosition: 'top',
    enableToolbar: false,
    showToolbar: true,
    toolbarHiddenButtons: [
      ['strikeThrough','superscript', 'subscript','subscript','insertImage', 'insertVideo', 'unlink', 'removeFormat', 'lcode','toggleEditorMode','insertHorizontalRule','insertLink']
    ],
    defaultFontSize: '3',
    sanitize: true
  };
  
export function getEditorConfig(): AngularEditorConfig {
    return editorConfig;
}